import { FormField } from 'app/form-fields/common/register/form-field';
import { FormFieldHeader } from 'app/form-fields/common/register/form-field-header/form-field-header';

type ColumnId = string;
type FormId = string;
type FormFieldWithFormId = FormField & { formId: FormId };

export class FormsRegisterColumn {
  public readonly id: ColumnId;
  public fieldsMap: Map<FormId, FormField> = new Map();

  private _fields: FormFieldWithFormId[];

  constructor(public header: FormFieldHeader) {
    this.id = header.id;
  }

  public addField({ id, field }: { id: FormId; field: FormField }) {
    this._fields = null;
    this.fieldsMap.set(id, field);
  }

  public get fields(): FormFieldWithFormId[] {
    if (!this._fields) {
      const fields = [];
      this.fieldsMap.forEach((field, formId) => {
        fields.push({ ...field, formId });
      });
      this._fields = fields;
    }
    return this._fields;
  }

  public removeField(formId: FormId) {
    this._fields = null;
    this.fieldsMap.delete(formId);
  }
}
